module.exports = __webpack_public_path__ + "img/horizontal_7_2_8011.e0bb6830.png";